import { defineStyle } from "@chakra-ui/react";
import RESOURCES from "../../resourses/RESOURCES";

export const TaskScreenStyles = (isMobile = false) => {
  return {
    mainContainer: defineStyle({
      height: "100vh",
      backgroundColor: RESOURCES?.colors?.CONTAINER_BACKGROUND,
      overflow: "auto",
      padding: 10,
      paddingX: { base: 4, md: 2, lg: 10 },
    }),
    subContainer: defineStyle({
      marginBottom: ["40px", "40px", "160px", "250px", "250px", "200px"],
    }),
    subbContainer: defineStyle({
      flexDirection: "row",
      alignItems: "flex-start",
      display: "grid",
      gridTemplateColumns: "repeat(14,1fr)",
      gap: "24px",
    }),
    vinImage: defineStyle({
      // width: "auto",
      zIndex: 1,
      gridColumn: { base: "1/3", md: "1/2", lg: "2/3", xl: "2/3" },
      marginLeft: ["0px", "0px", "0px", "0", "40px", "40px"],
      alignItems: "flex-start",
      width: { base: "28px", md: "50px" },
      height: { base: "32px", md: "56px" },
      objectFit: "contain",
    }),
    rightContainer: defineStyle({
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      gridColumn: { base: "1/15", md: "2/14", lg: "3/13" },
      gap: "20px",
    }),
    rightTopContainer: defineStyle({
      w: "100%",
      borderRadius: "0px 12px 12px 12px",
      alignItems: "flex-start",
      backgroundColor: {
        base: RESOURCES?.colors?.CONTAINER_BACKGROUND,
        md: "#E9E5FF",
      },
      padding: { base: "0px", md: "20px" },
    }),
    userGreetings: defineStyle({
      w: "100%",
      gap: { base: "10px", md: "10px" },
      paddingRight: { base: "16px", md: "0px" },
      paddingTop: { base: "16px", md: "0px" },
      paddingLeft: { base: "16px", md: "20px" },
      paddingBottom: "6px",
    }),
    userName: defineStyle({
      fontFamily: "Poppins",
      fontWeight: "600",
      marginBottom: { base: "0px", md: "0" },
      fontSize: { base: "16px", md: "24px" },
      lineHeight: { base: "24px", md: "36px" },
      textColor: { base: "#5F4DC7", md: "#000000D9" },
      textAlign: { base: "center", md: "left" },
    }),
    userMessage: defineStyle({
      fontFamily: "Poppins",
      fontWeight: "400",
      fontSize: { base: "14px", md: "16px" },
      lineHeight: "24px",
      textColor: { base: "#000000" },
      textAlign: { base: "center", md: "left" },
    }),
    optionContainer: defineStyle({
      position: "relative",
      flexDirection: "column",
      paddingLeft: { base: "0px", md: "20px" },
      width: "100%",
      marginTop: "10px",
      overflowX: "auto",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    }),
    subOptionContainer: defineStyle({
      width: "100%",
      gap: "16px",
      minW: "362px",
      display: "flex",
      justifyContent: isMobile && "center",
    }),
    baseButton: defineStyle({
      borderRadius: { base: "4px", md: "30px" },
      height: "max-content",
      padding: "8px",
      minWidth: "110px",
      _hover: {
        color: RESOURCES?.colors?.WHITE,
        backgroundColor: RESOURCES?.colors?.FILTER_COLOR,
      },
    }),

    baseButtonText: defineStyle({
      fontFamily: "Poppins",
      fontSize: { base: "14px", md: "16px", lg: "16px", xl: "18px" },
      lineHeight: { base: "20px", md: "24px", lg: "26px", xl: "30px" },
      alignItems: "center",
    }),

    baseButtonCount: defineStyle({
      borderRadius: "50%",
      width: { base: "20px", md: "32px" },
      height: { base: "20px", md: "32px" },
      color: "#fff",
      fontSize: { base: "12px", md: "14px" },
      textAlign: "center",
      fontWeight: "600",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }),
    wrapContainer: defineStyle({
      minWidth: 0,
      maxWidth: { base: "100%", md: "auto" },
      width: { base: "max-content", md: "auto" },
    }),
    activeButton: defineStyle({
      color: RESOURCES?.colors?.WHITE,
      backgroundColor: RESOURCES?.colors?.FILTER_COLOR,
      padding: "8px",
    }),
    passiveButton: defineStyle({
      color: RESOURCES?.colors?.FILTER_COLOR,
      backgroundColor: RESOURCES?.colors?.WHITE,
      padding: "8px",
    }),
    buttonContainer: defineStyle({
      padding: {
        base: "0",
        md: "6px 2px",
        lg: "6px 2px",
      },
      display: "flex",
      alignItems: "center",
      gap: "4px",
    }),
    buttonTextPassive: defineStyle({
      fontWeight: "400",
    }),
    buttonTextActive: defineStyle({
      fontWeight: "600",
    }),
    upcomingButtonCount: defineStyle({
      backgroundColor: "#7ABC40",
    }),
    overdueButtonCount: defineStyle({
      backgroundColor: "#FF641A",
    }),
    completedButtonCount: defineStyle({
      backgroundColor: "#484653",
    }),
    taskCardContainer: defineStyle({
      width: "100%",
      // marginBottom: ["40px", "40px", "200px", "250px", "250px", "200px"],
    }),
    taskCardSubContainer: defineStyle({
      spacing: 0,
      flexDirection: "row",
    }),
    taskCardSubbContainer: defineStyle({
      width: {
        base: "100%",
        md: "100%",
        lg: "100%",
      },
      height: "max-content",
      backgroundColor: {
        base: "",
        md: "#E9E5FF",
        lg: "#E9E5FF",
      },
      borderRadius: "0px 12px 12px 12px",
      padding: {
        base: "0px",
        md: "0px 20px",
        lg: "0px  24px",
      },
      display: "flex",
      position: "relative",
      flexDirection: {
        base: "column",
        md: "column",
        lg: "column",
      },
    }),
    completedTaskCardSubbContainer: defineStyle({
      width: {
        base: "100%",
        md: "100%",
        lg: "100%",
      },
      height: "max-content",
      backgroundColor: {
        base: "",
        md: "#CFE8B9CC",
        lg: "#CFE8B9CC",
      },
      borderRadius: "0px 12px 12px 12px",
      padding: {
        base: "0px",
        md: "0px 40px",
        lg: "0px  24px",
      },
      display: "flex",
      position: "relative",
      flexDirection: {
        base: "column",
        md: "column",
        lg: "column",
      },
    }),
    taskCardSection: defineStyle({
      padding: { base: "0", md: "20px" },
    }),
    optionTitleTaskCardSection: defineStyle({
      width: "100%",
      fontFamily: "poppins",
      fontWeight: 600,
      fontSize: "20px",
      textColor: "#3A0CA3",
      lineHeight: "30px",
    }),
    taskCardWrapContainer: defineStyle({
      marginBottom: "32px",
      borderRadius: 20,
      // gap: "32px",
      justifyContent: "space-between",
      width: "100%",
      py: [1, 2, 3, 4],
      flexDirection: {
        base: "column",
        md: "column",
        lg: "row",
      },
    }),
    cardSuperContainer: defineStyle({
      width: {
        base: "100%",
        md: "100%",
        lg: "auto",
      },
      display: "flex",
    }),
    emptyTasksMainContainer: defineStyle({
      padding: {
        base: "0px",
        md: "20px 60px",
        lg: "20px  44px",
      },
      bg: "linear-gradient(139.61deg, rgba(255, 255, 255, 0.3) 4.47%, rgba(255, 255, 255, 0) 98.47%);",
      backdropFilter: "blur(40px)",
      borderRadius: "16px",
    }),
    emptyTasksContainer: defineStyle({
      paddingTop: "36px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    }),
    emptyTasksContainerTitle: defineStyle({
      fontFamily: "Poppins",
      fontWeight: "600",
      fontSize: "18px",
      paddingTop: "16px",
      color: "#353535",
    }),
    emptyTasksContainerDescription: defineStyle({
      fontFamily: "Poppins",
      fontWeight: "600",
      fontSize: "15px",
      color: "#919191",
      paddingTop: "5px",
      marginBottom: "36px",
    }),
    bottomInput: defineStyle({
      position: "fixed",
      left: "0",
      bottom: "0",
      width: "100%",
      bg: isMobile && "#F5F4FA",
      backdropFilter: isMobile && "blur(70px)",
    }),
    bottomBox: defineStyle({
      height: "24px",
      bgColor: "#F5F4FA",
    }),
    completedTaskBox: defineStyle({
      justifyContent: "space-between",
      alignItems: "center",
      pr: ["0px", "0px", "0px", "24px", "24px", "24px"],
    }),
    completedCountText: defineStyle({
      fontFamily: "Poppins",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "24px",
      color: "#000000BF",
    }),
    completedViewList: defineStyle({
      color: "#3A0CA3",
      cursor: "pointer",
      fontFamily: "Poppins",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "24px",
    }),
    overdueBottomBox: defineStyle({
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      p: 4,
      pb: 8,
      pr: ["0px", "0px", "0px", "32px", "32px", "32px"],
    }),
    overdueBottomBoxText: defineStyle({
      color: "#3A0CA3",
      cursor: "pointer",
      fontFamily: "Poppins",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "24px",
    }),
    subjectFilterParent: defineStyle({
      width: "100%",
      overflowX: "auto",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
      // pt: { base: 2, md: 0 },
    }),
  };
};
